import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SettingsService } from '../../../core/services/settings.service';
import { NotificationService } from '../../../core/services/notification.service';
import { NotificationSettingsDto } from '../../../core/models/notification-settings.model';

@Component({
  selector: 'app-notifications-settings',
  imports: [CommonModule, FormsModule],
  templateUrl: './notifications-settings.html',
  styleUrl: './notifications-settings.scss',
})
export class NotificationsSettings implements OnInit {
  isLoading = false;
  isSaving = false;

  notificationSettings: NotificationSettingsDto = {
    id: '',
    patientAppointmentEmailReminder: true,
    reminderHoursBefore: 24,
  };

  browserNotifications = false;

  constructor(
    private settingsService: SettingsService,
    private notificationService: NotificationService,
  ) {}

  ngOnInit(): void {
    this.loadNotificationSettings();
  }

  private loadNotificationSettings(): void {
    this.isLoading = true;

    this.settingsService.getNotificationSettings().subscribe({
      next: (settings) => {
        this.notificationSettings = settings;
        this.isLoading = false;
      },
      error: (error) => {
        this.notificationService.error(
          'Failed to load notification settings: ' +
            (error?.error?.message || error.message || 'Unknown error'),
        );
        this.isLoading = false;
      },
    });
  }

  saveNotificationSettings(): void {
    this.isSaving = true;

    this.settingsService.updateNotificationSettings(this.notificationSettings).subscribe({
      next: (updatedSettings) => {
        this.notificationSettings = updatedSettings;
        this.notificationService.success('Notification settings saved successfully.');
        this.isSaving = false;
      },
      error: (error) => {
        this.notificationService.error(
          'Failed to save notification settings: ' +
            (error?.error?.message || error.message || 'Unknown error'),
        );
        this.isSaving = false;
      },
    });
  }
}
